module.exports = __webpack_public_path__ + "static/media/WhatsApp.76ad9f77.png";